import {PureComponent} from "react";

import './style.css';


class PageHeader extends PureComponent {

    render() {
        return (<div style={{fontSize: this.props.textSize}}>{this.props.headerValue}</div>);
    }

}

export default PageHeader;